import * as types from './actionTypes';
// ---- local imports ----

function start(actionType) {
	return (dispatch) => {
		dispatch({
			type: types.LOADING_START,
			actionType,
		});
	};
}

function end(actionType) {
	return {
		type: types.LOADING_END,
		actionType,
	};
}

function endAfterNetworkFaliures() {
	return {
		type: types.LOADING_END_NETWORK_FAILURE
	}
}

export { start, end, endAfterNetworkFaliures };
